import { toast } from '@components';
import {
  appToggleApplication,
  store,
  userPrefsSetAssetFiltersAction,
  userPrefsSetTempAction,
  userPrefsSetPressureAction,
  userPrefsSetDistanceAction,
} from '@redux';
import { Api } from '@services';
import { useEffect, useState } from 'react';
import { useQuery } from 'react-query';
import { connect, useDispatch } from 'react-redux';
import { appService } from '../../services';
import { UserSettingsForm } from './UserSettingsForm';

const UserSettingsContainer = ({ onDone }) => {
  const { data: apps } = useQuery(['appselector-applications'], () => appService.getAppsList(2000));
  const dispatch = useDispatch();
  const [user, setUser] = useState<any>({});
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [isError, setIsError] = useState<boolean>(false);

  useEffect(() => {
    const fetchData = async () => {
      setIsError(false);
      setIsLoading(true);
      try {
        const resp = await Api.get(`/users`);
        const userData = resp.data;
        let storedFilters = JSON.parse(localStorage.getItem('assetFilters')) ?? [];

        store.dispatch(userPrefsSetAssetFiltersAction(storedFilters));

        setUser({ ...userData, assetFilters: storedFilters });
      } catch (error) {
        setIsError(true);
      }
      setIsLoading(false);
    };
    fetchData();
  }, []);

  const updateUser = (payload: any) => {
    // Ensure units remain unchanged if not updated
    payload.temperatureUnit = payload.temperatureUnit || user.temperatureUnit;
    payload.distanceUnit = payload.distanceUnit || user.distanceUnit;
    payload.pressureUnit = payload.pressureUnit || user.pressureUnit;

    // Track if user manually removes or adds "Active Assets"
    const hasActiveAssets = payload.assetFilters?.includes('active(true)') || false;

    localStorage.setItem('userRemovedActiveAssets', JSON.stringify(!hasActiveAssets));

    // Save asset filters
    if (payload.assetFilters) {
      localStorage.setItem('assetFilters', JSON.stringify(payload.assetFilters));
      store.dispatch(userPrefsSetAssetFiltersAction(payload.assetFilters));
    }

    // Save unit prefs to localStorage
    localStorage.setItem('temperatureUnit', payload.temperatureUnit);
    localStorage.setItem('distanceUnit', payload.distanceUnit);
    localStorage.setItem('pressureUnit', payload.pressureUnit);

    // Update user preferences via API
    Api.put(`/users`, payload)
      .then(() => {
        // Update Redux
        store.dispatch(userPrefsSetTempAction(payload.temperatureUnit));
        store.dispatch(userPrefsSetPressureAction(payload.pressureUnit));
        store.dispatch(userPrefsSetDistanceAction(payload.distanceUnit));

        // Ensure filters are fresh
        if (payload.assetFilters !== undefined) {
          store.dispatch(userPrefsSetAssetFiltersAction(payload.assetFilters));
        }

        toast.success('Successfully updated User Preferences!');

        // Handle default app switching
        if (payload.DefaultApplicationId !== undefined) {
          const defaultApp = apps?.find((app) => app.id === payload.DefaultApplicationId);
          const app = defaultApp ? { id: defaultApp.id, name: defaultApp.name } : '';
          localStorage.setItem('defaultApplication', JSON.stringify(app));
        }
      })
      .catch(() => {
        setIsError(true);
        toast.error('Failed to update User Preferences.');
      });
  };

  return (
    <UserSettingsForm
      userProfile={user}
      updateUser={updateUser}
      isLoading={isLoading}
      isError={isError}
      onDone={onDone}
    />
  );
};

const mapStateToProps = ({ auth }) => {
  return {
    userId: auth.user.id,
    currentApp: auth.user.defaultApplication,
  };
};

export default connect(mapStateToProps)(UserSettingsContainer);
